/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponsePathwayDto } from '../../models/response-pathway-dto';
import { UpdatePathwayDto } from '../../models/update-pathway-dto';

export interface PathwaysControllerUpdate$Params {

/**
 * Tenant identifier
 */
  tenant: string;

/**
 * Pathway creation timestamp
 */
  createdAt: string;
  
    /**
     * The pathway data to update
     */
    body: UpdatePathwayDto
}

export function pathwaysControllerUpdate(http: HttpClient, rootUrl: string, params: PathwaysControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponsePathwayDto>> {
  const rb = new RequestBuilder(rootUrl, pathwaysControllerUpdate.PATH, 'put');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('createdAt', params.createdAt, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponsePathwayDto>;
    })
  );
}

pathwaysControllerUpdate.PATH = '/thalea-pathways/pathways/{tenant}/{createdAt}';
